import { List, Skeleton } from '@mui/material';

function SkeletonList({ count = 10, height = '45px' }) {
  return (
    <List>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          variant="rectangular"
          sx={{ height, mb: 0.5 }}
        />
      ))}
    </List>
  );
}

export default SkeletonList;
